<app-loading *ngIf="contentReady"></app-loading>

<div class="auth-vcash-page" style="margin-bottom: 50px;">

  <!-- TOP BLACK AREA -->
  <section class="auth-top">
    <div class="auth-top__inner">
      <div class="auth-logo-pill">
        <img class="auth-brand-logo" src="/assets/e-commerce/icons/48.webp" alt="ZAZU Logo" />
      </div>

      <div class="auth-top__content">
        <span class="auth-mini-badge">{{ "welcomeinblue" | transloco }}</span>
        <h1 class="auth-top__title">{{ "Log in" | transloco }}</h1>
        <p class="auth-top__desc">{{ "intro-desc" | transloco }}</p>
      </div>
    </div>
  </section>

  <!-- MAIN CONTENT -->
  <div class="auth-content">

    <!-- FORM CARD -->
    <section class="auth-card">
      <div class="auth-card__header">
        <h2 class="auth-card__title">{{ "Log in" | transloco }}</h2>
        <p class="auth-card__sub">{{ "welcomeinblue" | transloco }}</p>
      </div>

      <div *ngIf="!loggedIn; else loggedBlock">
        <form class="auth-form" [formGroup]="person" (ngSubmit)="onSubmit()">

          <div class="auth-form-group">
            <label class="auth-label" for="username">{{ "phone" | transloco }}</label>
            <div class="auth-input-wrap">
              <input class="auth-input" type="text" id="username" formControlName="username"
                placeholder="{{ 'username' | transloco }}" />
            </div>
          </div>

          <div class="auth-form-group">
            <label class="auth-label" for="Password">{{ "Password" | transloco }}</label>

            <div class="auth-input-wrap auth-password-wrap">
              <input class="auth-input" id="Password" type="{{ isPasswordVisible ? 'text' : 'password' }}"
                formControlName="password" placeholder="{{ 'Password' | transloco }}" />

              <button type="button" class="auth-toggle-password" (click)="togglePasswordVisibility()">
                @if(!isPasswordVisible){
                {{ "Show Password" | transloco }}
                } @else {
                {{ "Hide Password" | transloco }}
                }
              </button>
            </div>
          </div>

          <button type="submit" class="auth-submit-btn">
            {{ "Log in" | transloco }}
          </button>

          <div class="auth-divider"></div>

          <div class="auth-register-box">
            <span>{{ "askforacc" | transloco }}</span>
            <a routerLink="/Resigter">
              {{ "Create Account" | transloco }}
            </a>
          </div>
        </form>
      </div>

      <ng-template #loggedBlock>
        <div class="auth-logged-box">
          <div class="auth-logged-icon">
            <img src="/assets/e-commerce/icons/48.webp" alt="logged in" />
          </div>
          <h3>{{ "logged in" | transloco }}</h3>
        </div>
      </ng-template>
    </section>

    <!-- QUICK BENEFITS -->
    <section class="auth-benefits">
      <div class="auth-benefits__header">
        <h3>{{ "welcomeinblue" | transloco }}</h3>
      </div>

      <div class="auth-benefits-grid">
        <div class="auth-benefit-card">
          <div class="auth-benefit-icon">
            <img class="auth-brand-logo" src="/assets/e-commerce/icons/83.webp" alt="ZAZU Logo" />
          </div>
          <span>{{ "easy" | transloco }}</span>
        </div>

        <div class="auth-benefit-card">
          <div class="auth-benefit-icon">
            <img class="auth-brand-logo" src="/assets/e-commerce/icons/85.webp" alt="ZAZU Logo" />
          </div>
          <span>{{ "fast shopping" | transloco }}</span>
        </div>

        <div class="auth-benefit-card">
          <div class="auth-benefit-icon">
            <img class="auth-brand-logo" src="/assets/e-commerce/icons/84.webp" alt="ZAZU Logo" />
          </div>
          <span>{{ "daily_offer" | transloco }}</span>
        </div>

        <div class="auth-benefit-card">
          <div class="auth-benefit-icon">
            <img class="auth-brand-logo" src="/assets/e-commerce/icons/86.webp" alt="ZAZU Logo" />
          </div>
          <span>{{ "smooth experience" | transloco }}</span>
        </div>
      </div>
    </section>

  </div>
</div>